export default "__VITE_ASSET__c599503d__"